var map = {
	"./1.png": 55935,
	"./2.png": 42372,
	"./3.png": 84877,
	"./4.png": 3314,
	"./Abhishek.webp": 31578,
	"./Aman.webp": 56728,
	"./Anthropic-Identity_Logo_Website.png": 4167,
	"./Anthropic-Identity_Logo_Website.webp": 66244,
	"./Avanish.webp": 66331,
	"./Beamlab-logo.png": 17274,
	"./Beamlab-logo.webp": 60395,
	"./BlinkNow.webp": 80227,
	"./CAB.webp": 72637,
	"./Darshan.webp": 64140,
	"./Digu_Logo_Primary.png": 91392,
	"./Digu_Logo_Primary.webp": 81037,
	"./Digu_Logo_White.png": 37689,
	"./Digu_Logo_White.webp": 76274,
	"./Icon1.svg": 64710,
	"./Icon2.svg": 63845,
	"./Icon3.svg": 9124,
	"./Icon4.svg": 71275,
	"./Icon5.svg": 52218,
	"./Icon6.svg": 67305,
	"./IconHand.svg": 30866,
	"./JP1.png": 94429,
	"./JP1.svg": 3225,
	"./JP2.png": 13222,
	"./JP2.svg": 60874,
	"./JP3.png": 94767,
	"./JP3.svg": 2843,
	"./JP4.png": 9392,
	"./JP4.svg": 87572,
	"./JP5.svg": 32501,
	"./JP6.svg": 19542,
	"./JP7.svg": 59079,
	"./JP8.svg": 78512,
	"./JP9.svg": 76961,
	"./Job-placement_neu.jpg": 46128,
	"./Job-placement_neu.webp": 51401,
	"./LOGOS_1824x48_re.png": 12546,
	"./Learninghub-banner-mobile.svg": 1107,
	"./Line-blue.svg": 99281,
	"./Line-orange.svg": 50775,
	"./Okta.webp": 1200,
	"./SWLOGOWHITE.png": 15436,
	"./Screenshot_2023-11-01_at_4.08.59_PM.png": 95024,
	"./SmartWorks_PrimaryLogo_L001_SeabreezeBlue.svg": 59394,
	"./SmartWorks_PrimaryLogo_L001_SmartWhite.svg": 51860,
	"./Sudhir.webp": 91514,
	"./Sunbid.webp": 92188,
	"./Wave-01.svg": 79095,
	"./Wave-02.svg": 35972,
	"./a-secure-and-productive-work-environment.webp": 30068,
	"./about-hero.webp": 15785,
	"./about-hero@2x.webp": 36089,
	"./about-hero@3x.webp": 17548,
	"./about-mission.webp": 5833,
	"./about-mission@2x.webp": 85945,
	"./about-mission@3x.webp": 35724,
	"./about-vision.webp": 35641,
	"./about-vision@2x.webp": 25641,
	"./about-vision@3x.webp": 36028,
	"./accelerate-time.svg": 88953,
	"./accelerated-time-to-market.webp": 45359,
	"./accountability.svg": 6355,
	"./actionable-strategies.svg": 82894,
	"./adaptation.svg": 92837,
	"./affordable-solutions.svg": 67015,
	"./ankit_kumar_sha.webp": 44496,
	"./anthropic-cover.svg": 40576,
	"./anthropic-logo.png": 51140,
	"./anthropic-logo.svg": 77302,
	"./anwesh_dahal.webp": 12450,
	"./augumentation-hero.svg": 92760,
	"./balance.svg": 65586,
	"./bishesh_dangol.webp": 10357,
	"./blognotfound.svg": 79531,
	"./brand-consistency.svg": 58286,
	"./businessGrowth.svg": 16165,
	"./calendar.svg": 81780,
	"./candidate.svg": 51457,
	"./cares-hero.webp": 34832,
	"./cares_hero_bg.svg": 32367,
	"./cares_programs.jpeg": 35919,
	"./carrier-opportunity.svg": 28030,
	"./cb.svg": 98097,
	"./certified-professionals.svg": 6786,
	"./coder_level_1.webp": 99523,
	"./communicator.webp": 96802,
	"./compeititve-salaries-and-enhanced-living-standards.webp": 14867,
	"./competitive-pay.svg": 15518,
	"./compliance.svg": 38631,
	"./contact-hero-bg.svg": 85989,
	"./copy.svg": 22541,
	"./cost-effective-solutions.webp": 66493,
	"./cost-effective.svg": 25825,
	"./creative_specialist.webp": 85652,
	"./curve-line-blue.svg": 69759,
	"./curve-line-orange.svg": 57489,
	"./customer-cover.svg": 66920,
	"./customer-divac.svg": 11136,
	"./customer-satisfaction.svg": 97487,
	"./d1.png": 97697,
	"./d2.png": 48714,
	"./d3.png": 87571,
	"./d4.png": 3964,
	"./d5.png": 33381,
	"./deal.svg": 98816,
	"./deliver-result.svg": 81925,
	"./design-service.jpg": 66080,
	"./designApp-hero.svg": 39034,
	"./dev-service-wave.svg": 46349,
	"./developer-hiring-bg-1.svg": 27024,
	"./developer-hiring-bg-2.svg": 16419,
	"./developer-hiring-bg-3.svg": 13106,
	"./developer-hiring-bg-4.svg": 47037,
	"./developer-hiring-bg.svg": 74674,
	"./developer-section-bg.webp": 62429,
	"./developers-vector.svg": 67301,
	"./development.webp": 41606,
	"./digu-professionals.jpg": 50326,
	"./digu-professionals.svg": 51148,
	"./digu-startups.jpeg": 67211,
	"./digu-startups.svg": 56730,
	"./discord.svg": 82146,
	"./divac-logo.svg": 96629,
	"./divacs-cover.svg": 41568,
	"./driving.svg": 50171,
	"./educational-support.svg": 68077,
	"./efficient-planning.svg": 69351,
	"./effort-less-payroll-and-compliance.webp": 77673,
	"./empowering-your-career-trajectory.webp": 23189,
	"./endToend-support.svg": 6919,
	"./enhanced-engagement.svg": 92008,
	"./erp.svg": 43165,
	"./event-hero-background.svg": 49460,
	"./excellence.svg": 24056,
	"./execute-contracts.svg": 57373,
	"./experience-nepal-bg.svg": 67917,
	"./expert-developer.svg": 16195,
	"./facebook.svg": 51378,
	"./flexible-scalability.svg": 10093,
	"./flexible-scalability.webp": 17656,
	"./focused-development.svg": 79397,
	"./for-developers-hero.webp": 75847,
	"./for-developers-hero@2x.webp": 96959,
	"./for-developers-hero@3x.webp": 59642,
	"./for-hiring-companies-hero.svg": 67862,
	"./for-hiring-companies-hero.webp": 73463,
	"./for-hiring-companies-hero@2x.webp": 96655,
	"./for-hiring-companies-hero@3x.webp": 46858,
	"./fwa.svg": 56304,
	"./get-a-tailored-solution.svg": 30501,
	"./global-innovators.svg": 26833,
	"./grow-your-carrier.svg": 32622,
	"./growth.svg": 96723,
	"./hari_roka.webp": 90567,
	"./heart-hand.svg": 75324,
	"./help-vector.svg": 88309,
	"./hero-roadmap.svg": 79057,
	"./hero-section-bg.svg": 98532,
	"./hero-staff-augmentation.svg": 97516,
	"./hired.svg": 23516,
	"./hiring-company-section-bg.webp": 8128,
	"./home-big-data.webp": 31200,
	"./home-cloud.webp": 86126,
	"./home-custom-software-development.webp": 64812,
	"./home-hero.webp": 76497,
	"./home-hero@2x.webp": 11073,
	"./home-hero@3x.webp": 62100,
	"./home-mobile-and-web.webp": 40188,
	"./home-third-party.webp": 54623,
	"./home-why-we-exist.webp": 794,
	"./home-why-we-exist@2x.webp": 29704,
	"./home-why-we-exist@3x.webp": 16389,
	"./home-why-we-exist_.webp": 36419,
	"./home_why-we-exist_neu.jpg": 20882,
	"./home_why-we-exist_neu.webp": 13887,
	"./hwb.svg": 74105,
	"./ict.svg": 7186,
	"./identity-management-hero.svg": 1669,
	"./identity-step1.svg": 18036,
	"./identity-step2.svg": 5895,
	"./identity-step3.svg": 18774,
	"./identity-step4.svg": 94009,
	"./immediate-integration.svg": 37724,
	"./indepth-analysis.svg": 70553,
	"./innovation.svg": 12723,
	"./instagram.svg": 86166,
	"./interview-pre-vetted-candidates.svg": 35511,
	"./interview-schedule.svg": 83435,
	"./interview.svg": 6083,
	"./james_bonifield.webp": 40798,
	"./job-creation.svg": 21515,
	"./job-placement-hero-2.webp": 76078,
	"./job-placement-hero.jpg": 95004,
	"./job-placement-hero.webp": 77573,
	"./job-promotion.svg": 57291,
	"./ktm.webp": 64889,
	"./lazy-img.jpg": 16520,
	"./learninghub-banner-desktop.svg": 47047,
	"./line.svg": 98400,
	"./linkedin.svg": 43816,
	"./mailsubmit.svg": 14355,
	"./map.svg": 78908,
	"./market-ready-focus.svg": 27495,
	"./market-testing.svg": 55017,
	"./match-your-tech-stack.svg": 21099,
	"./meet-your-team-and-kickoff-your-project.svg": 68449,
	"./missionAndVision-mobile.svg": 83698,
	"./missionAndVision.svg": 80275,
	"./mvp-dev-service.svg": 67669,
	"./mvp-development-img1.svg": 70168,
	"./mvp-development-img2.svg": 9003,
	"./nav-home-icon.png": 83175,
	"./newsletterbackground.svg": 39575,
	"./nischal_shakya.webp": 86469,
	"./onboard-candidates.svg": 95426,
	"./onboard-talents.svg": 55313,
	"./outsource-your-projects.png": 806,
	"./payroll-compliance.svg": 99771,
	"./pd.svg": 65794,
	"./peak-performance.svg": 56806,
	"./people-analyzing-stuff.svg": 75604,
	"./people-climbing-ladder.svg": 88146,
	"./performance-optimization.svg": 45750,
	"./person-jumping.svg": 69358,
	"./person-with-laptop.svg": 4687,
	"./pfl.svg": 78660,
	"./pr.svg": 47036,
	"./presentation.svg": 47026,
	"./programs-section.png": 12781,
	"./programs-section.webp": 89822,
	"./project-management.webp": 97086,
	"./project-manager.svg": 36539,
	"./project_leader.webp": 13229,
	"./pt.svg": 41650,
	"./public-service.svg": 27219,
	"./qa-engineer.svg": 71190,
	"./quotes.svg": 29941,
	"./rb.svg": 50306,
	"./reliability.svg": 38818,
	"./respect.svg": 13780,
	"./resume.svg": 92343,
	"./review-hero.svg": 6323,
	"./righ-arrow.svg": 13824,
	"./right-arrow.svg": 2916,
	"./risk-reduction.svg": 29839,
	"./round-the-clock-availability.webp": 53714,
	"./round-the-clock.svg": 93885,
	"./rubin_maharjan.webp": 79972,
	"./ryan_schultz.webp": 84421,
	"./ryan_schultz_old.webp": 15823,
	"./san-diego.webp": 8964,
	"./scalability-icon.svg": 44423,
	"./scalability.svg": 61459,
	"./scalable-solution.svg": 99549,
	"./schedule-an-intro-call.svg": 11943,
	"./seamless-integration.svg": 26374,
	"./secure-solution.svg": 48583,
	"./security-enhancements.svg": 39328,
	"./service-dsaas-one.webp": 39616,
	"./service-dsaas-one@2x.webp": 25238,
	"./service-dsaas-one@3x.webp": 40395,
	"./service-dsaas-three.webp": 57148,
	"./service-dsaas-three@2x.webp": 17034,
	"./service-dsaas-three@3x.webp": 9359,
	"./service-frame-batch.svg": 39172,
	"./service-icon-clock.svg": 92978,
	"./service-img.svg": 8145,
	"./service-img2.svg": 29809,
	"./service-sdaas-one.webp": 88334,
	"./service-sdaas-one@2x.webp": 64324,
	"./service-sdaas-one@3x.webp": 785,
	"./service-sdaas-three.webp": 30150,
	"./service-sdaas-three@2x.webp": 8188,
	"./service-sdaas-three@3x.webp": 10633,
	"./service-sdaas-two.webp": 31744,
	"./service-sdaas-two@2x.webp": 93622,
	"./service-sdaas-two@3x.webp": 42955,
	"./sharpscribe-logo.svg": 16720,
	"./sharpscribe.svg": 78136,
	"./shirish_parajuli.webp": 11268,
	"./skill-development.svg": 20441,
	"./smartworks-cares-carousel-slide-one.webp": 12253,
	"./smartworks-cares-carousel-slide-one@2x.webp": 32453,
	"./smartworks-cares-carousel-slide-one@3x.webp": 4296,
	"./smartworks-cares-carousel-slide-three.webp": 70621,
	"./smartworks-cares-carousel-slide-two.webp": 79907,
	"./smartworks-central-carousel-slide-four.webp": 85756,
	"./smartworks-central-carousel-slide-four@2x.webp": 1578,
	"./smartworks-central-carousel-slide-four@3x.webp": 77551,
	"./smartworks-central-carousel-slide-one.webp": 60252,
	"./smartworks-central-carousel-slide-one@2x.webp": 44906,
	"./smartworks-central-carousel-slide-one@3x.webp": 89647,
	"./smartworks-central-carousel-slide-three.webp": 96248,
	"./smartworks-central-carousel-slide-three@2x.webp": 65198,
	"./smartworks-central-carousel-slide-three@3x.webp": 68707,
	"./smartworks-central-carousel-slide-two.webp": 2862,
	"./smartworks-central-carousel-slide-two@2x.webp": 46756,
	"./smartworks-central-carousel-slide-two@3x.webp": 81265,
	"./smartworks-central-hero-image.webp": 64799,
	"./smartworks-central-hero.webp": 66779,
	"./smartworks-central-hero@2x.webp": 82187,
	"./smartworks-central-hero@3x.webp": 49206,
	"./smartworks-logo.webp": 85548,
	"./sra.svg": 98482,
	"./step1.svg": 76529,
	"./step2.svg": 21986,
	"./step3.svg": 84627,
	"./story-card-bg.svg": 5868,
	"./story-card-corner.svg": 15726,
	"./story-card-hover-bg.svg": 81831,
	"./streamlined-recruitment-process.webp": 10310,
	"./swtp-badges_Coder.svg": 19847,
	"./swtp-badges_Coder.webp": 49432,
	"./swtp-badges_Communicator.svg": 20389,
	"./swtp-badges_Communicator.webp": 54724,
	"./swtp-badges_Interview.svg": 72361,
	"./swtp-badges_Interview.webp": 94194,
	"./teamwork.svg": 15034,
	"./technical.svg": 97759,
	"./tell-us-your-requirements.svg": 32113,
	"./temp/Aerials.png": 28230,
	"./temp/Finder.png": 87187,
	"./temp/HyperSpeed.png": 85436,
	"./temp/Lieder.png": 21160,
	"./temp/Minerva.png": 50045,
	"./temp/Mongo.png": 93275,
	"./temp/smartworks-cares-carousel-slide-three.webp": 64598,
	"./temp/swtp-badges_Coder.webp": 81155,
	"./temp/swtp-badges_Communicator.webp": 38105,
	"./temp/swtp-badges_Interview.webp": 75329,
	"./thankyou-image.svg": 23203,
	"./tiktok.svg": 824,
	"./tranining-hero-background.svg": 80394,
	"./udbodh_shrestha.webp": 59994,
	"./ujjwal_raja_maharjan.webp": 79544,
	"./underline.svg": 4242,
	"./understanding-digu-img.jpeg": 38166,
	"./understanding.svg": 73012,
	"./unlimited.svg": 2603,
	"./unlocking-opportunities-with-top-global-innovators.webp": 89144,
	"./user-center.svg": 49739,
	"./user-feedback.svg": 62557,
	"./verify.svg": 71401,
	"./vetted.svg": 72950,
	"./wave-bg-lighten.svg": 99541,
	"./wave-fur-animation-1.png": 70120,
	"./wave-fur-animation.png": 24490,
	"./wave-fur-animation.svg": 56408,
	"./wave-vector-light-blue.svg": 91225,
	"./wave-vector-purple.svg": 70866,
	"./wave-vector.svg": 59851,
	"./welt.svg": 50866,
	"./whymatter-surya.jpg": 80956,
	"./whymatter.svg": 70979,
	"./work-place-that-works.svg": 18406,
	"./x-twitter.svg": 13192,
	"./youtube.svg": 85797
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 21382;